var dataMap = {
    informations: [
        {
            label: Loc.g('Nom'),
            id: 'name',
            format: 'text',
            favoriteName: 'informations_name',
        },
        {
            label: Loc.g('Prénom'),
            id: 'forename',
            format: 'text',
            favoriteName: 'informations_forename',
        },
        {
            label: Loc.g('Fonction'),
            id: 'position',
            format: 'text',
            favoriteName: 'informations_position',
        },
        {
            label: Loc.g('Téléphone'),
            id: 'phone',
            format: 'phone',
            favoriteName: 'informations_phone',
        },
        {
            label: Loc.g('Mobile'),
            id: 'mobile',
            format: 'phone',
            favoriteName: 'informations_mobile',
        },
        {
            label: Loc.g('Email'),
            id: 'email',
            format: 'email',
            favoriteName: 'informations_email',
        },
        {
            label: Loc.g('Date de naissance'),
            id: 'birthdate',
            format: 'text',
            favoriteName: 'informations_birthdate',
        },
        {
            label: Loc.g('Facebook'),
            id: 'facebook',
            format: 'external_url',
            favoriteName: 'informations_facebook',
        },
        {
            label: Loc.g('X (Twitter)'),
            id: 'twitter',
            format: 'external_url',
            favoriteName: 'informations_twitter',
        },
        {
            label: Loc.g('Linkedin'),
            id: 'linkedin',
            format: 'external_url',
            favoriteName: 'informations_linkedin',
        },
        {
            label: Loc.g('Instagram'),
            id: 'instagram',
            format: 'external_url',
            favoriteName: 'informations_instagram',
        },
        {
            label: Loc.g('Site Web'),
            id: 'web',
            format: 'external_url',
            favoriteName: 'informations_web',
        },
    ],
    third: [
        {
            label: Loc.g('Nom'),
            id: 'name',
            format: 'link',
            favoriteName: 'third_{position}_name',
        },
        {
            label: Loc.g('Site Web'),
            id: 'web',
            format: 'external_url',
            favoriteName: 'third_{position}_web',
        },
        {
            label: Loc.g('Contact principal'),
            level: 'mainContact',
            id: 'fullName',
            format: 'text',
            favoriteName: 'third_{position}_fullName',
        },
    ],
};

var navMap = [
    {
        id: 'informations',
        label: '',
        items: [
            {
                id: 'activity',
                label: Loc.g('Activité'),
                group: false,
                component: 'tab-activity',
                permission: 'can_show_activity',
                databot: 'contact-overview__menu--activity',
                more: {},
            },
            {
                id: 'informations',
                label: Loc.g('Informations générales'),
                group: false,
                component: 'tab-informations-people',
                databot: 'contact-overview__menu--general-info',
                more: {},
            },
            {
                id: 'thirds',
                label: Loc.g('Sociétés liées'),
                group: false,
                component: 'tab-thirds',
                databot: 'contact-overview__menu--company-linked',
                more: {
                    buttons: [
                        {
                            label: Loc.g('Ajouter / Lier une société'),
                            callback: 'javascript:People.linkForm({id});',
                            permission: 'can_link_third',
                        },
                    ],
                },
            },
            {
                id: 'addresses',
                label: Loc.g('Adresses'),
                group: false,
                component: 'tab-addresses',
                permission: 'can_show_addresses',
                databot: 'contact-overview__menu--address',
                more: {
                    buttons: [
                        {
                            id: 'seemap',
                            type: 'function',
                            label: Loc.g('Voir la carte'),
                            primary: false,
                            event: 'openAddressMap',
                            dataUpsell: 'map_listing',
                        },
                        {
                            id: 'add',
                            type: 'function',
                            label: Loc.g('Ajouter une adresse'),
                            primary: true,
                            permission: 'can_create_addresses',
                            event: 'openAddress',
                        },
                    ],
                },
            },
            {
                id: 'customfields',
                label: Loc.g('Champs personnalisés'),
                group: false,
                component: 'tab-customfields',
                databot: 'contact-overview__menu--cf',
                more: {
                    url: '/rest/peoples/{linkedid}/custom-field-values',
                    buttons: [
                        {
                            type: 'function',
                            label: Loc.g('Editer'),
                            primary: true,
                            permission: 'can_edit',
                            event: 'openCustomfields',
                            params: {},
                        },
                    ],
                },
            },
        ],
    },
    {
        id: 'plugin',
        label: Loc.g('Modules'),
        items: [
            {
                id: 'emailingprofile',
                label: Loc.g('Profil emailing'),
                group: {
                    id: 'mailinglist',
                    label: Loc.g('Mailing lists'),
                },
                component: 'tab-listingv1',
                permission: 'can_show_mailinglist',
                databot: 'contact-overview__menu--mailing-list',
                more: {
                    tabType: 'total',
                    callbackKeyName: 'massMailingProfile',
                    title: Loc.g("Profil d'emailing"),
                    listingname: '',
                    url: '/?_f=massmailing_ajax',
                    action: 'loadMassMailingContactProfile',
                    type: 'people',
                    id: '{linkedid}',
                    buttons: [],
                },
            },
            {
                id: 'massmailingMailingList',
                label: Loc.g('Mailing lists'),
                group: {
                    id: 'mailinglist',
                    label: Loc.g('Mailing lists'),
                },
                component: 'tab-listingv1',
                permission: 'can_show_mailinglist',
                databot: 'contact-overview__menu--mailing-list',
                more: {
                    title: Loc.g('Mailing lists'),
                    listingname: 'massmailingMailinglist',
                    url: '/?_f=massmailing_ajax',
                    action: 'loadMassMailingContactListingTab',
                    type: 'people',
                    id: '{linkedid}',
                    buttons: [],
                },
            },
            {
                id: 'massmailingCampaignList',
                label: Loc.g('Liste des campagnes'),
                group: {
                    id: 'mailinglist',
                    label: Loc.g('Mailing lists'),
                },
                component: 'tab-listingv1',
                permission: 'can_show_mailinglist',
                databot: 'contact-overview__menu--mailing-list',
                more: {
                    title: Loc.g('Liste des campagnes'),
                    listingname: 'massmailingCampaignList',
                    url: '/?_f=massmailing_ajax',
                    action: 'loadMassMailingContactListingTab',
                    type: 'people',
                    id: '{linkedid}',
                    buttons: [],
                },
            },
            {
                id: 'briefcase',
                label: Loc.g('Fichiers'),
                group: false,
                component: 'tab-briefcase',
                permission: 'can_show_briefcase',
                databot: 'contact-overview__menu--briefcase',
                more: {
                    title: '',
                    url: '/?_f=briefcasev2',
                    action: 'loadBriefcaseTab',
                    linkedid: '{linkedid}',
                    linkedtype: '{linkedtype}',
                    linkedtypeDir: 'people',
                    linkedname: '{linkedname}',
                    editpermission: 'editpeople',
                    buttons: [],
                },
            },
        ],
    },
];

var headerActions = [
    {
        label: Loc.g('Modifier le contact'),
        type: 'js',
        value: "javascript:People.edit('peopleOverview', {id})",
        permission: 'can_edit',
    },
    {
        label: Loc.g('Supprimer le contact'),
        type: 'js',
        value: "javascript:People.deleteOne({id}, '', '{csrf_token}')",
        permission: 'can_delete',
        display: 'can_show_action_delete',
    },
    {
        label: Loc.g('Archiver le contact'),
        type: 'js',
        value: "javascript:People.updateArchive({id}, 'N')",
        permission: 'can_edit',
        display: 'can_show_action_archive',
    },
    {
        label: Loc.g('Restaurer le contact'),
        type: 'js',
        value: "javascript:People.updateArchive({id}, 'Y')",
        permission: 'can_edit',
        display: 'can_show_action_unarchive',
    },
    {
        label: Loc.g('Télécharger la VCard'),
        type: 'js',
        value: "javascript:Utils.relocate('/?_f=people&action=vcard&pid={id}')",
        permission: true,
    },
    {
        label: Loc.g('Modifier le logo du contact'),
        type: 'function',
        value: 'uploadAvatar',
        permission: true,
    },
    {
        label: Loc.g('Recevoir la liste des traitements'),
        type: 'js',
        value: "javascript:Third.exportRegister('people', '{id}');",
        permission: 'can_download_treatments_list_via_menu',
        display: 'can_download_treatments_list_via_menu',
    },
];

var addressesActions = [
    {
        label: Loc.g('Modifier'),
        type: 'vuejs',
        link: 'openAddress',
        permission: 'can_edit_addresses',
    },
    {
        label: Loc.g('Supprimer'),
        type: 'vuejs',
        link: 'deleteItem',
        permission: 'can_delete_addresses',
    },
];

var thirdsActions = [
    {
        label: Loc.g('Voir'),
        type: 'link',
        link: '/thirds/{relationtype}/{id}',
        permission: true,
    },
    {
        label: Loc.g('Délier de cette société'),
        type: 'js',
        link: "javascript:People.removeLinked('{peopleid}', '{contactid}')",
        permission: 'can_unlink_third_{id}',
    },
];

var backlink = [
    {
        type: 'contact',
        url: '/people',
        label: Loc.g('Contacts'),
    },
];

var routes = [
    {
        id: 'favorite',
        value: '/rest/peoples/overviews/favorites',
    },
    {
        id: 'activityform',
        value: '/rest/peoples/{id}/activity',
    },
    {
        id: 'save',
        value: '/rest/peoples/{id}/{type}',
    },
];

var entitiesGroups = [
    {
        label: Loc.g('Activité'),
        value: 'contactActivity',
        entities: [
            'task',
            'event',
            'annotation',
            'email',
            'phonecall',
            'people',
            'snippettracking',
            'marketing',
        ],
    },
    {
        label: Loc.g('Prospection'),
        value: 'prospection',
        entities: ['campaign', 'opportunity', 'estimate', 'propdocument'],
    },
    {
        type: 'component',
        component: 'timeline-author-filter',
        label: Loc.g('Collaborateurs'),
        value: 'authors',
        filter: true,
        entities: [],
        display: 'block',
    },
];

var entitiesTabs = [
    {
        label: Loc.g('Activité'),
        value: 'activity',
        entities: [
            'task',
            'event',
            'annotation',
            'email',
            'phonecall',
            'thirdcontact',
            'marketing',
        ],
    },
    {
        label: Loc.g('Éléments épinglés'),
        value: 'pinned',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'people', 'marketing'],
    },
    {
        label: Loc.g('Commentaires'),
        value: 'note',
        entities: ['annotation'],
        databot: 'contact-overview__activity--comment-list',
    },
    {
        label: Loc.g('Emails'),
        value: 'email',
        entities: ['email'],
        databot: 'contact-overview__activity--email-list',
    },
    {
        label: Loc.g('Tâches'),
        value: 'task',
        entities: ['task'],
        databot: 'contact-overview__activity--task-list',
    },
    {
        label: Loc.g('Evènements'),
        value: 'event',
        entities: ['event'],
        databot: 'contact-overview__activity--event-list',
    },
    {
        label: Loc.g('Appels'),
        value: 'phonecall',
        entities: ['phonecall'],
        databot: 'contact-overview__activity--call-list',
    },
    {
        label: Loc.g('Marketing'),
        value: 'marketing',
        entities: ['marketing'],
        databot: 'contact-overview__activity--marketing-list',
    },
];

var defaultEntities = [
    'email',
    'phonecall',
    'annotation',
    'event',
    'task',
    'campaign',
    'opportunity',
    'estimate',
    'propdocument',
    'people',
    'thirdcontact',
    'snippettracking',
    'marketing',
];

var forcedLabel = [
    {
        value: 'people',
        label: Loc.g('Mises à jour'),
    },
];

var object = {
    idName: 'peopleid',
};

var databots = {
    activitycommentadd: 'contact-overview__activity--comment-add',
    emailadd: 'contact-overview__activity--email-add',
    calladd: 'contact-overview__activity--call-add',
    scheduledcalladd: 'contact-overview__activity--scheduled-call-add',
    taskadd: 'contact-overview__activity--task-add',
    eventadd: 'contact-overview__activity--event-add',
    generalinfoedit1: 'contact-overview__section--general-info-edit-1',
    generalinfoedit2: 'contact-overview__section--general-info-edit-2',
    marketing: 'contact-overview__section--marketing',
};

var agendaViewConfig = {
    relatedtype: 'people',
    nameCallbackFunction: 'People.loadAgendaTab',
    prefixXsl: 'people',
};

export {
    dataMap,
    navMap,
    headerActions,
    addressesActions,
    thirdsActions,
    backlink,
    routes,
    entitiesGroups,
    entitiesTabs,
    defaultEntities,
    forcedLabel,
    object,
    databots,
    agendaViewConfig,
};
